/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ field: NonNullable<unknown>, reason: NonNullable<unknown> }} Error_Product_Image_Design_FieldInputs */

const vi_error_product_image_design_field = /** @type {(inputs: Error_Product_Image_Design_FieldInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Thiết kế ảnh chưa hợp lệ ở ô ${i?.field} (${i?.reason}). Sửa ô đó rồi lưu lại.`)
};

/**

* @param {Error_Product_Image_Design_FieldInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const error_product_image_design_field = /** @type {((inputs: Error_Product_Image_Design_FieldInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Product_Image_Design_FieldInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_error_product_image_design_field(inputs)
});